import React, { useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate, useParams } from 'react-router-dom'
import { SuccessfullyModal } from '../../components/Modals/Modals'
import endPoints from '../../Repository/apiConfig'
import { getApi, putApi } from '../../Repository/Api'


const formatISODate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toISOString().split("T")[0]; // Returns date in YYYY-MM-DD format
};

const EditFAQ = () => {
    const navigate = useNavigate()
    const { id } = useParams();
    const [show, setShow] = useState(false)
    const [loading, setLoading] = useState(false);
    const [question, setQuiestion] = useState('');
    const [answer, setAnswer] = useState('');
    const [categoryId, setCategoryId] = useState("");
    const [status, setStatus] = useState('');
    const [count, setCount] = useState('');
    const [createdAt, setCreatedAt] = useState("");
    const [categoryname, setCategoryName] = useState('');
    const [category, setCategory] = useState([]);


    const fetchData = async () => {
        await getApi(endPoints.getfaqbyid(id), {
            setResponse: (response) => {
                setQuiestion(response?.data?.question || '');
                setAnswer(response?.data?.answer || '');
                setCategoryId(response?.data?.category || '');
                setStatus(response?.data?.status || '');
                setCount(response?.data?.viewCount || '');
                setCreatedAt(formatISODate(response?.data?.createdAt || ""));
            },
            setLoading,
            errorMsg: 'Failed to fetch data!',
        });
    };

    const fetchCategories = async () => {
        await getApi(endPoints.getallcategory, {
            setResponse: setCategory,
            setLoading: setLoading,
            errorMsg: "Failed to fetch Category!",
        });
    };


    useEffect(() => {
        fetchData();
        fetchCategories();
    }, [id])

    const handleUpdate = async () => {
        const payload = {
            question,
            answer,
            status,
            category: categoryId,
        };

        await putApi(endPoints.updatefaqbyid(id), payload, {
            setLoading,
            successMsg: 'FAQ updated successfully!',
            errorMsg: 'Failed to update FAQ!',
        });
        setShow(true);

        setTimeout(() => {
            setShow(false);
            navigate('/FAQ'); // Redirect to the Privacy Policy list page
        }, 2000);
    };







    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Updated"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Edit  FAQ</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View FAQ</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>FAQ  Details</h6>
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">QuestionTitle*</label>
                            <input
                                type="text"
                                placeholder='Enter the Question'
                                value={question}
                                onChange={(e) => setQuiestion(e.target.value)}
                            />
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Answer*</label>
                            <input
                                type="text"
                                placeholder='"Enter the Answer'
                                value={answer}
                                onChange={(e) => setAnswer(e.target.value)}
                            />
                        </div>
                        <div className={addjob.addvouchercontainer}>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Choose Category*</label>
                                <select
                                    value={categoryId}
                                    onChange={(e) => {
                                        const selectedCategory = category?.data?.find(
                                            (cat) => cat._id === e.target.value
                                        );
                                        setCategoryId(e.target.value);
                                        setCategoryName(selectedCategory?.name || "");
                                    }}
                                >
                                    <option value="">Select Category</option>
                                    {category?.data?.map((cat) => (
                                        <option key={cat._id} value={cat._id}>
                                            {cat.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Status*</label>
                                <select
                                    value={status}
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="">Select</option>
                                    <option value="Published">Published</option>
                                    <option value="UnPublished">UnPublished</option>
                                    <option value="Drafts">Drafts</option>
                                </select>
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">View Count*</label>
                                <input
                                    type="text"
                                    placeholder='View count'
                                    value={count}
                                    readOnly
                                />
                            </div>
                            <div className={addjob.addjobinputs}>
                                <label htmlFor="">Creation Date*</label>
                                <input
                                    type="date"
                                    value={createdAt}
                                    readOnly
                                />
                            </div>
                        </div>
                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button
                                onClick={handleUpdate}
                                style={{ background: '#F05423' }}
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update"}
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default HOC(EditFAQ)